import * as actionTypes from './actionTypes';

export function clearNotificationSnackbarAction() {
    return {
        type: actionTypes.CLEAR_NOTIFICATION_SNACKBAR,
    };
}

export function closeModalAction() {
    return {
        type: actionTypes.CLOSE_MODAL,
    };
}

export function closeModalDialogAction() {
    return {
        type: actionTypes.CLOSE_MODAL_DIALOG,
    };
}

export function closeRepModalAction() {
    return {
        type: actionTypes.CLOSE_REP_MODAL,
    };
}

export function closeSearchInputAction(listViewActive) {
    return {
        type: actionTypes.CLOSE_SEARCH_INPUT,
        listViewActive,
    };
}

export function clearSearchFilterTextAction(listViewActive) {
    return {
        type: actionTypes.CLEAR_SEARCH_FILTER_TEXT,
        listViewActive,
    };
}

export function clearDropdownAdditionalFiltersAction() {
    return {
        type: actionTypes.CLEAR_DROPDOWN_ADDITIONAL_FILTERS,
    };
}

export function dropDropdownAdditionalFiltersAction(filterKey) {
    return {
        type: actionTypes.DROP_DROPDOWN_ADDITIONAL_FILTERS,
        filterKey,
    };
}

export function downloadExportDataAction(exportSelection, storeIDs) {
    return {
        type: actionTypes.FILE_EXPORT_DATA,
        exportSelection,
        storeIDs,
    };
}

export function fileImportDataAction(importSelection, file) {
    return {
        type: actionTypes.FILE_IMPORT_DATA,
        importSelection,
        file,
    };
}

export function fetchActivityCardDetailsAction(data, storeNumberChanged = false) {
    return {
        type: actionTypes.FETCH_ACTIVITY_CARD_DETAILS,
        rangeStart: data.rangeStart,
        rangeEnd: data.rangeEnd,
        storeNumber: data.storeNumber,
        storeNumberChanged,
    };
}

export function fetchActivityListDetailsAction(storeNumberChanged = false) {
    return {
        type: actionTypes.FETCH_ACTIVITY_LIST_DETAILS,
        storeNumberChanged,
    };
}

export function fetchUserLocaleAction() {
    return {
        type: actionTypes.FETCH_USER_LOCALE,
    };
}

export function focusSearchInputAction(listViewActive) {
    return {
        type: actionTypes.SEARCH_INPUT_FOCUSED,
        listViewActive,
    };
}

export function getExecutionDashboardPreferencesAction() {
    return {
        type: actionTypes.FETCH_EXECUTION_DASHBOARD_PREFERENCES,
    };
}

export function hideToastAction(data) {
    return {
        type: actionTypes.HIDE_TOAST,
        toastId: data,
    };
}

export function loadExecutionDashboardAction() {
    return {
        type: actionTypes.LOAD_EXECUTION_DASHBOARD,
    };
}

export function openModalAction(data) {
    return {
        type: actionTypes.OPEN_MODAL,
        data,
    };
}

export function openModalDialogAction(dialogOpenId) {
    return {
        type: actionTypes.OPEN_MODAL_DIALOG,
        dialogOpenId,
    };
}

export function recalculateListViewDateAction(date, storeNumber) {
    return {
        type: actionTypes.RECALCULATE_LIST_VIEW_DATE,
        date,
        storeNumber,
    };
}

export function recalculateStartAndEndDatesAction(data) {
    return {
        type: actionTypes.RECALCULATE_START_AND_END_DATES,
        data,
    };
}

export function recalculateStartAndEndDatesAndTriggerModalAction(data) {
    return {
        type: actionTypes.RECALCULATE_DATES_AND_TRIGGER_MODAL,
        data,
    };
}

export function removeActivityCardNewIndicatorAction(data) {
    return {
        type: actionTypes.REMOVE_NEW_INDICATOR,
        activityID: data.activityID,
        selectedStore: data.selectedStore,
        beginWeekString: data.beginWeekString,
    };
}

export function requestRepDetailsAction(url) {
    return {
        type: actionTypes.REQUEST_REP_DETAILS,
        url,
    };
}

export function requestStoreNumberDropdownOptionsAction(url) {
    return {
        type: actionTypes.REQUEST_STORE_NUMBER_DROPDOWN_OPTIONS,
        url,
    };
}

export function selectChipAction(chipName, listViewActive) {
    return {
        type: actionTypes.CHIP_SELECTED,
        chipName,
        listViewActive,
    };
}

export function selectDefaultChipAction(listViewActive) {
    return {
        type: actionTypes.DEFAULT_CHIP_SELECTED,
        listViewActive,
    };
}

export const serverLoad = {
    success: (state) => ({ type: actionTypes.SERVER_LOAD_SUCCESS, payload: state }),
};

export function setActiveCardPositionAction(data) {
    return {
        type: actionTypes.SET_ACTIVE_CARD_POSITION,
        data,
    };
}

export function setCalendarViewSelectedStoreAndGrabDataAction(selectedStore) {
    return {
        type: actionTypes.SET_CALENDAR_VIEW_SELECTED_STORE_AND_GRAB_DATA,
        selectedStore,
    };
}

export function setDomainAction(domain) {
    return {
        type: actionTypes.SET_DOMAIN,
        payload: domain,
    };
}

export function setDropdownFilterDataAction(dropdownFilterChanged, dropdownFilterCount) {
    return {
        type: actionTypes.SET_DROPDOWN_FILTER_DATA,
        dropdownFilterChanged,
        dropdownFilterCount,
    };
}

export function setDropdownOptionsAction(dropdownOptions) {
    return {
        type: actionTypes.SET_DROPDOWN_OPTIONS,
        dropdownOptions,
    };
}

export function setDropdownAdditionalFiltersAction(filterKey) {
    return {
        type: actionTypes.SET_DROPDOWN_ADDITIONAL_FILTERS,
        filterKey,
    };
}

export function setDropdownKeyFiltersAction(dropdownKeyFilters) {
    return {
        type: actionTypes.SET_DROPDOWN_KEY_FILTERS,
        dropdownKeyFilters,
    };
}

export function setDropdownKeySearchAction(dropdownKeySearch) {
    return {
        type: actionTypes.SET_DROPDOWN_KEY_SEARCH,
        dropdownKeySearch,
    };
}

export function setDropdownSearchAction(filterKey, value) {
    return {
        type: actionTypes.SET_DROPDOWN_SEARCH,
        filterKey,
        value,
    };
}

export function setFormEditModeAction(formKey, editMode) {
    return {
        type: actionTypes.SET_FORM_EDIT_MODE,
        formKey,
        editMode,
    };
}

export function setFormIsSubmittingAction(isSubmitting) {
    return {
        type: actionTypes.SET_FORM_IS_SUBMITTING,
        isSubmitting,
    };
}

export function setFormValidatedAction(formKey, formValidated) {
    return {
        type: actionTypes.SET_FORM_VALIDATED_STATUS,
        formKey,
        formValidated,
    };
}

export function setFormInputErrorsAction(formKey, inputErrors) {
    return {
        type: actionTypes.SET_FORM_INPUT_ERRORS,
        formKey,
        inputErrors,
    };
}

export function setListViewDateAction(date) {
    return {
        type: actionTypes.SET_LIST_VIEW_DATE,
        date,
    };
}

export function setListViewSelectedStoreAndGrabDataAction(selectedStore) {
    return {
        type: actionTypes.SET_LIST_VIEW_SELECTED_STORE_AND_GRAB_DATA,
        selectedStore,
    };
}

export function setMapboxTokenAction(accessToken) {
    return {
        type: actionTypes.SET_MAPBOX_TOKEN,
        accessToken,
    };
}

export function setOuterModalContainerAction(data) {
    return {
        type: actionTypes.SET_OUTER_MODAL_ELEMENT,
        data,
    };
}

export function updateDropdownOptionsAction(filterKey, filteredOptionsKeys, checkedFlag, rowIndex) {
    return {
        type: actionTypes.UPDATE_DROPDOWN_OPTIONS,
        filterKey,
        filteredOptionsKeys,
        checkedFlag,
        rowIndex,
    };
}

export function setSearchFilterTextAction(searchFilterText, listViewActive) {
    return {
        type: actionTypes.SET_SEARCH_FILTER_TEXT,
        searchFilterText,
        listViewActive,
    };
}

export function resetDropdownSearchAction() {
    return {
        type: actionTypes.RESET_DROPDOWN_SEARCH,
    };
}

export function toggleActivityDetailAction() {
    return {
        type: actionTypes.TOGGLE_ACTIVITY_DETAIL,
    };
}

export function toggleCalendarViewAction() {
    return {
        type: actionTypes.TOGGLE_CALENDAR_VIEW,
    };
}

export function updateDropdownKeyFiltersAction(filteredOptionsKeys, checkedFlag) {
    return {
        type: actionTypes.UPDATE_DROPDOWN_KEY_FILTERS,
        filteredOptionsKeys,
        checkedFlag,
    };
}

export function resetDropdownKeyFiltersAction() {
    return {
        type: actionTypes.RESET_DROPDOWN_KEY_FILTERS,
    };
}

export function toggleEmployeeDetailAction() {
    return {
        type: actionTypes.TOGGLE_EMPLOYEE_DETAIL,
    };
}

export function toggleListViewAction() {
    return {
        type: actionTypes.TOGGLE_LIST_VIEW,
    };
}

export function toggleManagerDetailsAction() {
    return {
        type: actionTypes.TOGGLE_VIEW_MANAGEMENT,
    };
}

export function updateDropdownOptionsCountByKeyAction({ filterKey, filterValue, singleSelection }) {
    return {
        type: actionTypes.UPDATE_DROPDOWN_OPTIONS_COUNT_BY_KEY,
        filterKey,
        filterValue,
        singleSelection,
    };
}

export function updateDropdownOptionsWithFiltersAction(excludeFilterKey) {
    return {
        type: actionTypes.UPDATE_DROPDOWN_OPTIONS_WITH_FILTERS,
        excludeFilterKey,
    };
}

export function setColumnKeySearchAction(columnKeySearch) {
    return {
        type: actionTypes.SET_COLUMN_DROPDOWN_SEARCH,
        columnKeySearch,
    };
}

export function updateColumnKeyFiltersAction(colId) {
    return {
        type: actionTypes.UPDATE_COLUMN_DROPDOWN_FILTERS,
        colId,
    };
}

export function setModalColumnKeySearchAction(columnKeySearch) {
    return {
        type: actionTypes.SET_MODAL_COLUMN_DROPDOWN_SEARCH,
        columnKeySearch,
    };
}

export function setModalColumnKeyFiltersAction(columnKeyFilters) {
    return {
        type: actionTypes.SET_MODAL_COLUMN_DROPDOWN_FILTERS,
        columnKeyFilters,
    };
}
export function updateModalColumnKeyFiltersAction(colId) {
    return {
        type: actionTypes.UPDATE_MODAL_COLUMN_DROPDOWN_FILTERS,
        colId,
    };
}

export function setColumnKeyFiltersAction(columnKeyFilters) {
    return {
        type: actionTypes.SET_COLUMN_DROPDOWN_FILTERS,
        columnKeyFilters,
    };
}

export function updateDropdownFilterDataAction(data) {
    return {
        type: actionTypes.UPDATE_DROPDOWN_FILTER_DATA,
        filteredDropdownChanged: data.filteredDropdownChanged,
        filteredDropdownCount: data.filteredDropdownCount,
        filterKey: data.filterKey,
    };
}

export function setNestedDropdownSearchAction(filterKey, value, rowIndex) {
    return {
        type: actionTypes.SET_NESTED_DROPDOWN_SEARCH,
        filterKey,
        value,
        rowIndex,
    };
}

export function updateNestedDropdownOptionsCountByKeyAction(data) {
    return {
        type: actionTypes.UPDATE_NESTED_DROPDOWN_OPTIONS_COUNT_BY_KEY,
        parentIndex: data.parentIndex,
        rowIndex: data.rowIndex,
        filterKey: data.filterKey,
        filterValue: data.filterValue,
        singleSelection: data.singleSelection,
        mPlanID: data.mPlanID,
    };
}

export function clearDropdownsAction() {
    return {
        type: actionTypes.CLEAR_DROPDOWNS,
    };
}

export function addDropdownOptionsAction(data) {
    return {
        type: actionTypes.ADD_DROPDOWN_OPTIONS,
        optionName: data.optionName,
        optionData: data.optionData,
    };
}

export function loadDropdownOptionsAction(dropdownKey, initialLoad = false, countByFilteredLocations = false) {
    return {
        type: actionTypes.LOAD_DROPDOWN_OPTIONS,
        dropdownKey,
        initialLoad,
        countByFilteredLocations,
    };
}

export function updateAllDropdownOptionsAfterFilterAction(reportBuilderOption) {
    return {
        type: actionTypes.UPDATE_ALL_DROPDOWN_OPTIONS_AFTER_FILTER,
        reportBuilderOption,
    };
}

export function setDropdownDisplayNamesAction(nameMapping) {
    return {
        type: actionTypes.SET_DROPDOWN_DISPLAY_NAMES,
        nameMapping,
    };
}

export function clearDropdownSearchAction() {
    return {
        type: actionTypes.CLEAR_DROPDOWN_SEARCH,
    };
}

export function setSideNavActiveItemAction(activeItem) {
    return {
        type: actionTypes.SET_SIDE_NAV_ACTIVE_ITEM,
        activeItem,
    };
}

export function setImageDetailsAction(imageData) {
    return {
        type: actionTypes.IMAGE_FILE_DETAILS,
        payload: imageData,
    };
}

export function resetImageDetailsAction() {
    return {
        type: actionTypes.IMAGE_FILE_RESET,
    };
}

export function setImageFileAction(imageFile) {
    return {
        type: actionTypes.SET_IMAGE_FILE,
        imageFile,
    };
}

export function postImageFileAction(imageFilePath) {
    return {
        type: actionTypes.POST_IMAGE_FILE,
        imageFilePath,
    };
}

export function clearImageFileAction() {
    return {
        type: actionTypes.CLEAR_IMAGE_FILE,
    };
}

export const setImageErrorAction = (error) => ({
    type: actionTypes.SET_IMAGE_ERROR,
    error,
});

export function pushRepPhotoID() {
    return {
        type: actionTypes.SET_REP_PHOTO,
    };
}

export const updateUsersAction = (payload) => ({
    type: actionTypes.UPDATE_USERS,
    payload,
});

export const updateContactSearchAction = (searchText) => ({
    type: actionTypes.UPDATE_CONTACT_SEARCH_TEXT,
    searchText,
});

export const addContactUsersAction = (newUsersPayload) => ({
    type: actionTypes.ADD_CONTACT_USERS,
    payload: newUsersPayload,
});

export const resetContactsAction = () => ({
    type: actionTypes.RESET_CONTACTS,
});

export const findContactsAction = () => ({
    type: actionTypes.FIND_CONTACTS,
});

export const fetchUserInfoAction = () => ({
    type: actionTypes.FETCH_USER_INFO,
});

export const setUserInfoAction = (userInfo) => ({
    type: actionTypes.SET_USER_INFO,
    userInfo,
});

export function setUserTSAction(timestamp) {
    return {
        type: actionTypes.SET_USER_TS,
        timestamp,
    };
}

export function updateAgGridPageNumberAction(newPageNumber) {
    return {
        type: actionTypes.UPDATE_AG_GRID_PAGE_NUMBER,
        newPageNumber,
    };
}

export function updateGridRenderWaitStatusAction(gridRenderWait) {
    return {
        type: actionTypes.UPDATE_GRID_RENDER_WAIT_STATUS,
        gridRenderWait,
    };
}

export const createMessageThreadsAction = (payload) => ({
    type: actionTypes.CREATE_MESSAGE_THREADS,
    payload,
});

export const pollSyncThreadsAction = () => ({
    type: actionTypes.POLL_SYNC_THREADS,
});

export const syncActiveUsersAction = (payload) => ({
    type: actionTypes.SYNC_ACTIVE_USERS,
    payload,
});

export const syncContactUsersAction = (payload) => ({
    type: actionTypes.SYNC_CONTACT_USERS,
    payload,
});

export const syncInactiveUsersAction = (payload) => ({
    type: actionTypes.SYNC_INACTIVE_USERS,
    payload,
});

export const syncMessagesAction = (payload) => ({
    type: actionTypes.SYNC_MESSAGES,
    payload,
});

export const syncMessageThreadsAction = () => ({
    type: actionTypes.SYNC_MESSAGE_THREADS_CALL,
});

export const updateMessageThreadsAction = (updatedThreadsPayload) => ({
    type: actionTypes.UPDATE_MESSAGE_THREADS,
    payload: updatedThreadsPayload,
});

export const setSelectedThreadIDAction = (threadID) => ({
    type: actionTypes.SET_SELECTED_THREAD_ID,
    threadID,
});

export const updateMessageDataInThreadsAction = (updatedThreadsPayload) => ({
    type: actionTypes.UPDATE_MESSAGE_DATA_IN_THREADS,
    payload: updatedThreadsPayload,
});

export const getRolesAction = () => ({
    type: actionTypes.GET_ROLES,
});

export const addRolesAction = (payload) => ({
    type: actionTypes.ADD_ROLES,
    payload,
});

export const selectedRolesValueAction = (roleKey) => ({
    type: actionTypes.SELECTED_ROLE,
    payload: roleKey,
});

export const searchRolesAction = (searchText) => ({
    type: actionTypes.SEARCH_ROLE_VALUE,
    payload: searchText,
});

export const clearSearchRolesAction = () => ({
    type: actionTypes.CLEAR_SEARCH_ROLES,
});

export const selectAllRoleOptionsAction = (payload) => ({
    type: actionTypes.SELECT_ALL_ROLE_OPTIONS,
    payload,
});

export const deselectAllRoleOptionsAction = (payload) => ({
    type: actionTypes.DESELECT_ALL_ROLE_OPTIONS,
    payload,
});

export const syncAnnouncementsAction = (payload) => ({
    type: actionTypes.SYNC_ANNOUNCEMENTS,
    payload,
});

export const syncDraftAnnouncementsAction = () => ({
    type: actionTypes.SYNC_DRAFT_ANNOUNCEMENTS,
});

export const addDraftAnnouncementsAction = (payload) => ({
    type: actionTypes.ADD_DRAFT_ANNOUNCEMENTS,
    payload,
});

export const addNewAnnouncementsAction = (payload) => ({
    type: actionTypes.ADD_NEW_ANNOUNCEMENTS,
    payload,
});

export const deleteAnnouncementAction = (announcementPayload) => ({
    type: actionTypes.DELETE_ANNOUNCEMENT,
    payload: announcementPayload,
});

export const setLoadingAction = (loadingPayload) => ({
    type: actionTypes.LOADING_TOGGLE,
    isLoading: loadingPayload.isLoading,
});

export const getAnnouncementStatsAction = (announcementPayload) => ({
    type: actionTypes.GET_ANNOUNCEMENT_STATS,
    payload: announcementPayload,
});

export const getRetailersAction = (retailersList) => ({
    type: actionTypes.GET_RETAILERS,
    retailersList,
});

export const setRetailersAction = (retailers) => ({
    type: actionTypes.SET_RETAILERS,
    retailers,
});

export function showErrorStatusAction(errorCode, errorMessage = '', retryAction = '') {
    return {
        type: actionTypes.SHOW_ERROR_STATUS,
        errorCode,
        errorMessage,
        retryAction,
    };
}

export function hideErrorStatusAction() {
    return {
        type: actionTypes.HIDE_ERROR_STATUS,
    };
}

export function cancelInlineEditAction(status) {
    return {
        type: actionTypes.LIST_VIEW_UPDATE_CANCEL,
        status,
    };
}

export function saveInlineEditAction(mvid, payload) {
    return {
        type: actionTypes.LIST_VIEW_EDIT_UPDATE,
        mvid,
        payload,
    };
}

export function updateInlineCompleteAction(updateComplete) {
    return {
        type: actionTypes.LIST_VIEW_UPDATE_COMPLETE,
        updateComplete,
    };
}

export const showNotificationSnackbarAction = (message, bgType = '') => ({
    bgType,
    type: actionTypes.SET_NOTIFICATION_SNACKBAR,
    message,
});

export function setImportLoadingBarDataAction(data) {
    return {
        type: actionTypes.SET_IMPORT_LOADING_BAR_DATA,
        data,
    };
}

export function clearImportLoadingDataAction() {
    return {
        type: actionTypes.CLEAR_IMPORT_LOADING_BAR_DATA,
    };
}

export const setMessagesCacheAction = () => ({
    type: actionTypes.SET_MESSAGE_CACHE,
});

export const getMessagesCacheAction = (payload) => ({
    type: actionTypes.GET_MESSAGE_CACHE,
    payload,
});

export const setContactsCacheAction = () => ({
    type: actionTypes.SET_CONTACT_CACHE,
});

export const getContactsCacheAction = (payload) => ({
    type: actionTypes.GET_CONTACT_CACHE,
    payload,
});

export const setLastActiveCacheAction = (payload) => ({
    type: actionTypes.SET_LAST_ACTIVE_CACHE,
    payload,
});

export const getLastActiveCacheAction = (payload) => ({
    type: actionTypes.GET_LAST_ACTIVE_CACHE,
    payload,
});

export const setAnnouncementCacheAction = () => ({
    type: actionTypes.SET_ANNOUNCEMENT_CACHE,
});

export const getAnnouncementCacheAction = (payload) => ({
    type: actionTypes.GET_ANNOUNCEMENT_CACHE,
    payload,
});

export const updateAnnouncementPriorityFilter = (filterPayload) => ({
    type: actionTypes.UPDATE_ANNOUNCEMENT_PRIORITY_FILTER,
    selectedPriority: filterPayload.selectedPriority,
});

export const clearWorkingAnnouncementAction = () => ({
    type: actionTypes.CLEAR_WORKING_ANNOUNCEMENT,
});

export const setWorkingAnnouncementAction = (announcementPayload) => ({
    type: actionTypes.SET_WORKING_ANNOUNCEMENT,
    payload: announcementPayload,
});

export const publishAnnouncementAction = (announcementPayload) => ({
    type: actionTypes.PUBLISH_ANNOUNCEMENT,
    payload: announcementPayload,
});

export const saveDraftAnnouncementAction = (announcementPayload) => ({
    type: actionTypes.SAVE_DRAFT_ANNOUNCEMENT,
    payload: announcementPayload,
});

export const updateAnnouncementTypeAction = (typePayload) => ({
    type: actionTypes.UPDATE_ANNOUNCEMENT_TYPE,
    payload: typePayload,
});

export const updateAnnouncementTitleAction = (titlePayload) => ({
    type: actionTypes.UPDATE_ANNOUNCEMENT_TITLE,
    payload: titlePayload,
});

export const updateAnnouncementBodyAction = (bodyPayload) => ({
    type: actionTypes.UPDATE_ANNOUNCEMENT_BODY,
    payload: bodyPayload,
});

export const startAnnouncementPublishAction = () => ({
    type: actionTypes.START_ANNOUNCEMENT_PUBLISH,
});

export const endAnnouncementPublishAction = () => ({
    type: actionTypes.END_ANNOUNCEMENT_PUBLISH,
});

export const deleteDraftAnnouncementAction = (announcementPayload) => ({
    type: actionTypes.DELETE_DRAFT_ANNOUNCEMENT,
    payload: announcementPayload,
});

export const searchAnnouncement = (searchPayload) => ({
    type: actionTypes.SEARCH_ANNOUNCEMENT,
    searchText: searchPayload.searchText,
});

export const searchToggle = (togglePayload) => ({
    type: actionTypes.SEARCH_TOGGLE,
    searchHide: togglePayload.searchHide,
});

export const updateAnnouncementPriorityAction = (priorityPayload) => ({
    type: actionTypes.UPDATE_ANNOUNCEMENT_PRIORITY,
    payload: priorityPayload,
});

export const updateAnnouncementImageAction = (imageFile) => ({
    type: actionTypes.UPDATE_ANNOUNCEMENT_IMAGE,
    payload: imageFile,
});

export const updateAnnouncementAcknowledgment = (priorityPayload) => ({
    type: actionTypes.UPDATE_ANNOUNCEMENT_ACKNOWLEDGMENT_REQUIRED,
    payload: priorityPayload,
});

export const acknowledgeAnnouncementAction = (acknowledgmentPayload) => ({
    type: actionTypes.ACKNOWLEDGE_ANNOUNCEMENT,
    payload: acknowledgmentPayload,
});

export const assignPercentAcknowledged = (payload) => ({
    type: actionTypes.ASSIGN_PERCENT_ACKNOWLEDGED,
    payload,
});

export const goToMenuItemAction = (menuItemPayload) => ({
    type: actionTypes.GOTO_MENU_ITEM,
    payload: menuItemPayload,
});

export const setLoadingDraftAction = (loadingPayload) => ({
    type: actionTypes.LOADING_DRAFT_TOGGLE,
    isLoadingDraft: loadingPayload.isLoadingDraft,
});

export function updateSelectedRecipientsAction(selectedRecipients) {
    return {
        type: actionTypes.UPDATE_SELECTED_RECIPIENTS,
        selectedRecipients,
    };
}

export const addMessageSectionAction = (messagePayload) => ({
    type: actionTypes.ADD_MESSAGE_SECTION,
    payload: messagePayload,
});

export const addMessageAction = (messagePayload) => ({
    type: actionTypes.ADD_MESSAGE,
    payload: messagePayload,
});

export const updateMessageSearchAction = (searchText) => ({
    type: actionTypes.UPDATE_MESSAGE_SEARCH_TEXT,
    searchText,
});

export const setConversationViewed = (conversationPayload) => ({
    type: actionTypes.SET_CONVERSATION_VIEWED,
    payload: conversationPayload,
});

export const setForwardDataAction = (forwardData) => ({
    type: actionTypes.SET_FORWARD_DATA,
    forwardData,
});

export const deleteMessageIDAction = (messagePayload) => ({
    type: actionTypes.DELETE_MESSAGE_ID,
    payload: messagePayload,
});

export const deleteThreadIDAction = (threadId) => ({
    type: actionTypes.DELETE_THREAD_ID,
    threadId,
});

export const resendMessageIDAction = (messagePayload) => ({
    type: actionTypes.RESEND_MESSAGE_ID,
    payload: messagePayload,
});

export const removeImageFileAction = () => ({
    type: actionTypes.REMOVE_IMAGE_FILE,
});

export function findNewThreadsUsersAction(newUserIDs, contactsOnline, users) {
    return {
        type: actionTypes.NEW_THREADS_USERS,
        newUserIDs,
        contactsOnline,
        users,
    };
}

export const setPublishAnnouncementLoaderAction = (payload) => ({
    type: actionTypes.SET_PUBLISH_ANNOUNCEMENT_LOADER,
    payload,
});

export const hideMapDetailAction = () => ({
    type: actionTypes.HIDE_MAP_DETAIL,
});

export const setTotalMapRecordsAction = (totalRecords) => ({
    type: actionTypes.SET_TOTAL_MAP_RECORDS,
    totalRecords,
});

export const updateSelectedLocationsAction = (selectedLocations) => ({
    type: actionTypes.UPDATE_SELECTED_LOCATIONS,
    selectedLocations,
});

export const checkedLocationAction = (selectedRows) => ({
    type: actionTypes.SET_CHECKBOX_SELECTION,
    selectedRows,
});

export const setGridPageNumberAction = (gridPageNumber) => ({
    type: actionTypes.SET_GRID_PAGE_NUMBER,
    gridPageNumber,
});

export const requestMapboxTokenAction = () => ({
    type: actionTypes.REQUEST_MAPBOX_TOKEN,
});

export const showMapDetailAction = (selectedMapPoint) => ({
    type: actionTypes.SHOW_MAP_DETAIL,
    selectedMapPoint,
});

export const updateMapAction = (gridPageNumber) => ({
    type: actionTypes.UPDATE_MAP_VIEW,
    gridPageNumber,
});
/**
 * @function createDropdownFilterAction for use with dropdown, action creator function for creating dropdowns
 * @param {string} filterKey - string for the the unique key for the dropdown filter {@link shared/reducers/dropdown/v2/dropdown.js} for dropdownFilter object shape
 * @param {string} displayName - string representing what the dropdown filter is called (the human readable text)
 * @param {string} displayName - string type of dropdown we expect to display
 * @returns {object}
 */
export function createDropdownFilterAction(filterKey, displayName) {
    return {
        type: actionTypes.CREATE_DROPDOWN_FILTER,
        filterKey,
        displayName,
    };
}

/**
 * @function removeDropdownFilterAction for use with dropdown, action creator function for removing dropdown filters
 * @param {string} filterKey - string for the the unique key for the dropdown filter {@link shared/reducers/dropdown/v2/dropdown.js} for dropdownFilter object shape
 * @returns {object}
 */
export function removeDropdownFilterAction(filterKey) {
    return {
        type: actionTypes.REMOVE_DROPDOWN_FILTER,
        filterKey,
    };
}

/**
 * @function selectDropdownFilterValueAction for use with dropdown, action creator function for selecting a dropdown option value
 * @param {string} filterKey - string for the the unique key for the dropdown filter {@link shared/reducers/dropdown/v2/dropdown.js} for dropdownFilter object shape
 * @param {string} value - string representing the value of the dropdown option
 * @returns {object}
 */
export function selectDropdownFilterValueAction(filterKey, value) {
    return {
        type: actionTypes.SELECT_DROPDOWN_FILTER_VALUE,
        filterKey,
        value,
    };
}

/**
 * @function selectSingleDropdownFilterValueAction for use with dropdown, action creator function for selecting a single dropdown option value, and deselecting all others
 * @param {string} filterKey - string for the the unique key for the dropdown filter {@link shared/reducers/dropdown/v2/dropdown.js} for dropdownFilter object shape
 * @param {string} value - string representing the value of the dropdown option
 * @param {boolean} allowUncheck - boolean for allowing the user to uncheck the selected value
 * @returns {object}
 */
export function selectSingleDropdownFilterValueAction(filterKey, value, allowUncheck = false) {
    return {
        type: actionTypes.SELECT_SINGLE_DROPDOWN_FILTER_VALUE,
        filterKey,
        value,
        allowUncheck,
    };
}

/**
 * @function selectAllDropdownFilterValuesAction for use with dropdown, action creator function for selecting all dropdown option values
 * @param {string} filterKey - string for the the unique key for the dropdown filter {@link shared/reducers/dropdown/v2/dropdown.js} for dropdownFilter object shape
 * @param {array} optionValues - array of dropdown values corresponding to what's in view, ergo if you've filtered values to two out of ten, you'd only check/uncheck the two that are in view
 * @returns {object}
 */
export function selectAllDropdownFilterValuesAction(filterKey, optionValues) {
    return {
        type: actionTypes.SELECT_ALL_DROPDOWN_VALUES,
        filterKey,
        optionValues,
    };
}

/**
 * @function checkAllFilteredDropdownValues for use with dropdown, action creator function for setting all dropdown option values to checked
 * @param {string} filterKey - string for the the unique key for the dropdown filter {@link shared/reducers/dropdown/v2/dropdown.js} for dropdownFilter object shape
 * @param {array} optionValues - array of dropdown values corresponding to what's in view, ergo if you've filtered values to two out of ten, you'd only check/uncheck the two that are in view
 * @returns {object}
 */
export const checkAllFilteredDropdownValues = (filterKey, optionValues) => ({
    type: actionTypes.SET_ALL_DROPDOWN_VALUES_TRUE,
    filterKey,
    optionValues,
});

/**
 * @function clearAllFilteredDropdownValues for use with dropdown, action creator function for setting all dropdown option values to unchecked
 * @param {string} filterKey - string for the the unique key for the dropdown filter {@link shared/reducers/dropdown/v2/dropdown.js} for dropdownFilter object shape
 * @param {array} optionValues - array of dropdown values corresponding to what's in view, ergo if you've filtered values to two out of ten, you'd only check/uncheck the two that are in view
 * @returns {object}
 */
export const clearAllFilteredDropdownValues = (filterKey, optionValues) => ({
    type: actionTypes.SET_ALL_DROPDOWN_VALUES_FALSE,
    filterKey,
    optionValues,
});

/**
 * @function setDropdownFilterSearchValueAction for use with dropdown, action creator function for setting a searchFilter value for a dropdown
 * @param {string} filterKey - string for the the unique key for the dropdown filter {@link shared/reducers/dropdown/v2/dropdown.js} for dropdownFilter object shape
 * @param {string} searchValue - string representing the search value
 * @returns {object}
 */
export function setDropdownFilterSearchValueAction(filterKey, searchValue = '') {
    return {
        type: actionTypes.SET_DROPDOWN_FILTER_SEARCH_FILTER,
        filterKey,
        searchValue,
    };
}

/**
 * @function setDropdownFilterOptionsAction for use with dropdown, action creator function for setting a searchFilter value for a dropdown
 * @param {string} filterKey - string for the the unique key for the dropdown filter {@link /shared/reducers/dropdown/v2/dropdown.js} for dropdownFilter object shape
 * @param {object} dropdownOptions - object of dropdown option objects, see  {@link /shared/utils/DropdownUtil/DropdpownUtil.js} for dropdown option object shape
 * @returns {object}
 */
export function setDropdownFilterOptionsAction(filterKey, dropdownOptions = {}) {
    return {
        type: actionTypes.SET_DROPDOWN_FILTER_OPTIONS,
        filterKey,
        dropdownOptions,
    };
}

/**
 * @function replaceDropdownFilterOptionsAction for use with dropdown, action creator function for replacing a searchFilter value options with new options
 * @param {string} filterKey - string for the the unique key for the dropdown filter {@link /shared/reducers/dropdown/v2/dropdown.js} for dropdownFilter object shape
 * @param {object} dropdownOptions - object of dropdown option objects, see  {@link /shared/utils/DropdownUtil/DropdpownUtil.js} for dropdown option object shape
 * @returns {object}
 */
export function replaceDropdownFilterOptionsAction(filterKey, dropdownOptions = {}) {
    return {
        type: actionTypes.REPLACE_DROPDOWN_FILTER_OPTIONS,
        filterKey,
        dropdownOptions,
    };
}

/**
 * @function clearMoreDropdownFiltersAction for use with dropdown, action creator function for clearing 'More Filters', more filters being ephemeral option dropdown filters that can be selected if additonal filtering is required.
 * @param {array} moreFiltersConfig - array of dropdown configuration objects
 *   {
 *     @property {string} uniqueKey - unique value identifying a dropdown filter
 *     @property {string} text - display name for the dropdown
 *   },
 * @param {object} moreFiltersOptions - object of dropdown option objects, see  {@link /shared/utils/DropdownUtil/DropdpownUtil.js} for dropdown option object shape
 * @returns {object}
 */
export function clearMoreDropdownFiltersAction(moreFiltersConfig, moreFiltersOptions) {
    return {
        type: actionTypes.CLEAR_MORE_DROPDOWN_FILTERS,
        moreFiltersConfig,
        moreFiltersOptions,
    };
}

/**
 * @function setDateDropdownSelectionAction for use with dropdown, action creator function for setting options on a date type filter
 * @param {string} filterKey - string for the the unique key for the dropdown filter {@link /shared/reducers/dropdown/v2/dropdown.js} for dropdownFilter object shape
 * @param {string} startDate - string date for start of date range of filter
 * @param {string|null} endDate - date for end of date range of filter. null if not passed as end is optional if we aren't doing a range
 * @returns {object}
 */
export const setDateDropdownSelectionAction = (filterKey, startDate, endDate = null) => ({
    type: actionTypes.SET_DROPDOWN_DATE_FILTER_SELECTION,
    filterKey,
    startDate,
    endDate,
});

export const setIsLoadingAction = (payload = '') => ({
    type: actionTypes.SET_IS_LOADING,
    key: payload,
});

export const unsetIsLoadingAction = (payload = '') => ({
    type: actionTypes.UNSET_IS_LOADING,
    key: payload,
});

// Start mPlanReissueForm actions
/**
 * @function setConfirmReissueCancelIdAction to set id as confirmation before mPlan is actually reissued
 * @param {Integer} id -- id as confirmation before mPlan is actually reissued
 * @returns {object}
 */
export function setConfirmReissueCancelIdAction({ id }) {
    return {
        type: actionTypes.SET_REISSUE_CONFIRM_CANCEL,
        id,
    };
}

/**
 * @function setConfirmReissueCancelDataAction to set data as confirmation before mPlan is actually reissued
 * @param {Object} data -- data to be passed to send to backend
 * @returns {object}
 */
export function setConfirmReissueCancelDataAction({ data }) {
    return {
        type: actionTypes.SET_REISSUE_CONFIRM_CANCEL_DATA,
        data,
    };
}

/**
 * @function setReissueIncludeResponsesPreferenceAction to set IncludeResponse options as true/false from the server
 * @param {Boolean} value
 * @returns {object}
 */
export function setReissueIncludeResponsesPreferenceAction(value) {
    return {
        type: actionTypes.SET_REISSUE_INCLUDE_RESPONSES_PREFERENCE,
        value,
    };
}

/**
 * @function setReissueFormCloseAction -- closes ReissueForm
 * @returns {object}
 */
export function setReissueFormCloseAction() {
    return {
        type: actionTypes.SET_REISSUE_FORM_CLOSE,
    };
}

/**
 * @function setReissueFormOpenAction -- open ReissueForm from anywhere in the app
 * @param {Object} mPlan - mPlan Data
 * @param {Object} location - location Data
 * @returns {object}
 */
export function setReissueFormOpenAction({ mPlan, location }) {
    return {
        type: actionTypes.SET_REISSUE_FORM_OPEN,
        mPlan,
        location,
    };
}

/**
 * @function setReissueRepDataAction -- set Reissue Rep selection for ReissueForm
 * @param {Object} repData -- object with keys and value for Rep selection options {@link @see '../modules/ReissueRepInput/ReissueRepInput.test.js' for payload}
 * @returns {object}
 */
export function setReissueRepDataAction({ repData }) {
    return {
        type: actionTypes.SET_REISSUE_REP_DATA,
        repData,
    };
}

/**
 * @function setReissueDataToUpdateAction -- Updates row for existing data in Work grid
 * @param {Object} data -- object with keys to update Ag-Grid row. @required 'id' as one of the keys
 * @returns {object}
 */
export function setReissueDataToUpdateAction({ data }) {
    return {
        type: actionTypes.SET_REISSUED_MPLAN_DATA_TO_UPDATE,
        data,
    };
}

/**
 * @function requestCancelReissueMplanAction -- Request to cancel an already reissued mPlan
 * @param {Object} data -- object with keys to remove certain mPlan at Location
 * @returns {object}
 */
export function requestCancelReissueMplanAction({ data }) {
    return {
        type: actionTypes.REQUEST_CANCEL_REISSUE_MPLAN,
        data,
    };
}

/**
 * @function reissueMplanAction -- Request to reissue an mPlan
 * @param {Date.Element} expirationDate -- Reissue Expiration Date
 *      @example format: moment().toDate()
 * @param {String} feedbackValue -- Optional Feedback for when Reissuing mPlan
 * @param {Boolean} includeResponses -- Reissue mPlan with Include Responses option
 * @param {Array} reissueRepSelected -- Arrays of RepIDs to reissue to
 * @param {Array} savedEmails -- Arrays of emails to send to when Reissuing mPlan
 *
 * @returns {object}
 */
export function reissueMplanAction({
    expirationDate,
    feedbackValue,
    includeResponses,
    reissueRepSelected,
    savedEmails,
}) {
    return {
        type: actionTypes.REQUEST_REISSUE_MPLAN,
        expirationDate,
        feedbackValue,
        includeResponses,
        reissueRepSelected,
        savedEmails,
    };
}

/**
 * @function requestRepDataAction -- Request to get Reissue Rep Selection when Reissuing mPlan
 * @param {Integer} locationId
 * @param {Integer} mPlanId
 * @param {Integer} submittedRepId
 *
 * @returns {object}
 */
export function requestRepDataAction({ locationId, mPlanId, submittedRepId }) {
    return {
        type: actionTypes.REQUEST_REISSUE_REP_DATA,
        locationId,
        mPlanId,
        submittedRepId,
    };
}

/**
 * @function requestRepDataAction -- Request to get Reissue Options on initial Reissue Form open
 * @returns {object}
 */
export function requestReissueWindowOptionsAction() {
    return {
        type: actionTypes.REQUEST_REISSUE_WINDOW_OPTIONS,
    };
}

export const getVisitCanReissueConditionAction = ({ mPlanId, locationId, data }) => ({
    type: actionTypes.GET_VISIT_CAN_REISSUE_CONDITION,
    mPlanId,
    locationId,
    data,
});

export const setVisitCanReissueConditionAction = ({ canReissue }) => ({
    type: actionTypes.SET_VISIT_CAN_REISSUE_CONDITION,
    canReissue,
});

// End mPlanReissueForm actions

export function setGridHeaderMenuFiltersAction({ gridKey, options }) {
    return {
        type: actionTypes.SET_GRID_HEADER_MENU_FILTERS,
        gridKey,
        options,
    };
}

export function loadCustomFieldListsAction() {
    return {
        type: actionTypes.LOAD_CUSTOM_FIELD_LISTS,
    };
}

export function setCustomFieldListsAction(lists) {
    return {
        type: actionTypes.SET_CUSTOM_FIELD_LISTS,
        lists,
    };
}

export function updateCustomFieldNameAction(name) {
    return {
        type: actionTypes.UPDATE_CREATE_CUSTOM_FIELD_NAME,
        name,
    };
}

export function clearCustomFieldNameAction() {
    return {
        type: actionTypes.CLEAR_CREATE_CUSTOM_FIELD_NAME,
    };
}

export function setCustomFieldErrorMessageAction(errorMsg) {
    return {
        type: actionTypes.SET_CREATE_CUSTOM_FIELD_ERROR_MESSAGE,
        errorMsg,
    };
}

export function clearCustomFieldErrorMessageAction() {
    return {
        type: actionTypes.CLEAR_CREATE_CUSTOM_FIELD_ERROR_MESSAGE,
    };
}

// workApprovalForm actions
export const setWorkApprovalFormData = ({ data }) => ({
    type: actionTypes.SET_WORK_APPROVAL_FORM_DATA,
    data,
});

export function requestWorkApproval({ feedback, emails, gridApi }) {
    return {
        type: actionTypes.REQUEST_WORK_APPROVAL,
        feedback,
        emails,
        gridApi,
    };
}

// GridView actions
export const setGridViewSideContentExpandStatus = ({ expandStatus }) => ({
    type: actionTypes.SET_GRID_VIEW_SIDE_CONTENT_EXPAND_STATUS,
    expandStatus,
});

export const setGridViewActiveSideContent = ({ activeSideContent }) => ({
    type: actionTypes.SET_GRID_VIEW_ACTIVE_SIDE_CONTENT,
    activeSideContent,
});

export function setGridViewOptionsAction({ gridKey, options }) {
    return {
        type: actionTypes.SET_GRID_VIEW_OPTIONS,
        gridKey,
        options,
    };
}

export function clearGridViewOptionsAction({ gridKey }) {
    return {
        type: actionTypes.SET_GRID_VIEW_OPTIONS,
        gridKey,
    };
}

export const setCacheByKeyAction = ({ gridKey, cacheURL, options }) => ({
    type: actionTypes.SET_CACHE_BY_KEY,
    gridKey,
    cacheURL,
    options,
});

export const getCacheByKeyAction = ({ gridKey, cacheURL }) => ({
    type: actionTypes.GET_CACHE_BY_KEY,
    gridKey,
    cacheURL,
});

export const clearCacheByKeyAction = ({ cacheURL }) => ({
    type: actionTypes.CLEAR_CACHE_BY_KEY,
    cacheURL,
});

// assignments actions
export const setAssignmentsAction = ({
    allAssignments,
    selectedAssignments,
    locationsCount,
}) => ({
    type: actionTypes.SET_ASSIGNMENTS,
    allAssignments,
    selectedAssignments,
    locationsCount,
});

export const updateSelectedAssignmentsAction = ({ selectedAssignments }) => ({
    type: actionTypes.UPDATE_SELECTED_ASSIGNMENTS,
    selectedAssignments,
});

export const setAssignmentsLocationsCountAction = ({ tempLocationsCount, locationsCountIsLoading }) => ({
    type: actionTypes.SET_ASSIGNMENTS_LOCATIONS_COUNT,
    tempLocationsCount,
    locationsCountIsLoading,
});

export const getAssignmentsAction = ({ objectId, objectType }) => ({
    type: actionTypes.GET_ASSIGNMENTS,
    objectId,
    objectType,
});

export const checkAssignmentsNodeOptionsAction = (node) => ({
    type: actionTypes.CHECK_ASSIGNMENTS_NODE_OPTIONS,
    node,
});

export const expandAssignmentsNodeOptionsAction = (node) => ({
    type: actionTypes.EXPAND_ASSIGNMENTS_NODE_OPTIONS,
    node,
});

export const updateAssignmentsNodeOptionsAction = (nodeToUpdate) => ({
    type: actionTypes.UPDATE_ASSIGNMENTS_NODE_OPTIONS,
    nodeToUpdate,
});

export const checkMultipleAssignmentsNodesAction = ({ nodes, checked, indeterminate }) => ({
    type: actionTypes.CHECK_MULTIPLE_ASSIGNMENTS_NODES,
    nodes,
    checked,
    indeterminate,
});

export const cancelAssignmentsChangesAction = () => ({
    type: actionTypes.CANCEL_ASSIGNMENTS_CHANGES,
});

export const saveAssignmentsChangesAction = ({ objectId, objectType, showNotification = true }) => ({
    type: actionTypes.SAVE_ASSIGNMENTS_CHANGES,
    objectId,
    objectType,
    showNotification,
});

export const setAssignmentsIsSavingStatusAction = ({ isSaving }) => ({
    type: actionTypes.SET_ASSIGNMENTS_IS_SAVING_STATUS,
    isSaving,
});

export const setAssignmentsIsQuickSelectAction = ({ isQuickSelect }) => ({
    type: actionTypes.SET_ASSIGNMENTS_IS_QUICK_SELECT,
    isQuickSelect,
});

export const getAssignmentsQuickSelectRetailersAction = () => ({
    type: actionTypes.GET_ASSIGNMENTS_QUICK_SELECT_RETAILERS,
});

export const setAssignmentsQuickSelectRetailersAction = ({ retailers }) => ({
    type: actionTypes.SET_ASSIGNMENTS_QUICK_SELECT_RETAILERS,
    retailers,
});

export const setAssignmentsQuickSelectRetailerSelectedAction = ({ retailer }) => ({
    type: actionTypes.SET_ASSIGNMENTS_QUICK_SELECT_RETAILER_SELECTED,
    retailer,
});

export const getAssignmentsQuickSelectLocationsByRetailerAction = ({ retailer }) => ({
    type: actionTypes.GET_ASSIGNMENTS_QUICK_SELECT_LOCATIONS_BY_RETAILER,
    retailer,
});

export const setAssignmentsQuickSelectLocationsByRetailerAction = ({ locations }) => ({
    type: actionTypes.SET_ASSIGNMENTS_QUICK_SELECT_LOCATIONS_BY_RETAILER,
    locations,
});

export const setAssignmentsQuickSelectLocationNumbersInputAction = ({ value }) => ({
    type: actionTypes.SET_ASSIGNMENTS_QUICK_SELECT_LOCATION_NUMBERS_INPUT,
    value,
});

export const setAssignmentsQuickSelectManualSaveAsListAction = ({ saveAsList }) => ({
    type: actionTypes.SET_ASSIGNMENTS_QUICK_SELECT_MANUAL_SAVE_AS_LIST,
    saveAsList,
});

export const setAssignmentsQuickSelectManualListNameAction = ({ listName }) => ({
    type: actionTypes.SET_ASSIGNMENTS_QUICK_SELECT_MANUAL_LIST_NAME,
    listName,
});

export const setAssignmentsQuickSelectManualSaveAsListErrorAction = ({ errorMsg }) => ({
    type: actionTypes.SET_ASSIGNMENTS_QUICK_SELECT_MANUAL_SAVE_AS_LIST_ERROR,
    errorMsg,
});

export const setAssignmentsQuickSelectUploadSaveAsListAction = ({ saveAsList }) => ({
    type: actionTypes.SET_ASSIGNMENTS_QUICK_SELECT_UPLOAD_SAVE_AS_LIST,
    saveAsList,
});

export const setAssignmentsQuickSelectUploadListNameAction = ({ listName }) => ({
    type: actionTypes.SET_ASSIGNMENTS_QUICK_SELECT_UPLOAD_LIST_NAME,
    listName,
});

export const setAssignmentsQuickSelectUploadedListIdAction = ({ listId }) => ({
    type: actionTypes.SET_ASSIGNMENTS_QUICK_SELECT_UPLOADED_LIST_ID,
    listId,
});

export const getAssignmentsLocationsCountAction = () => ({
    type: actionTypes.GET_ASSIGNMENTS_LOCATIONS_COUNT,
});

export const clearAssignmentsQuickSelectSelectionsAction = () => ({
    type: actionTypes.CLEAR_ASSIGNMENTS_QUICK_SELECT_SELECTIONS,
});

export const saveAssignmentsQuickSelectUploadCsvAction = () => ({
    type: actionTypes.SAVE_ASSIGNMENTS_QUICK_SELECT_UPLOAD_CSV,
});

export const saveAssignmentsQuickSelectManualEntryAction = () => ({
    type: actionTypes.SAVE_ASSIGNMENTS_QUICK_SELECT_MANUAL_ENTRY,
});

export const setAssignmentsVisitDetailsCsvModalOpenAction = ({ modalOpen }) => ({
    type: actionTypes.SET_ASSIGNMENTS_VISIT_DETAILS_CSV_MODAL_OPEN,
    modalOpen,
});

export const setAssignmentsHasRetailerOrCustomFieldSelectedAction = ({ hasAllRetailerOrCustomFieldSelected }) => ({
    type: actionTypes.SET_ASSIGNMENTS_HAS_RETAILER_OR_CUSTOM_FIELD_SELECTED,
    hasAllRetailerOrCustomFieldSelected,
});

export const saveAssignmentsVisitDetailsCsvAction = ({ mPlanId, file }) => ({
    type: actionTypes.SAVE_ASSIGNMENTS_VISIT_DETAILS_CSV,
    file,
    mPlanId,
});

export const downloadTemplateVisitDetailsCsvAction = ({ mPlanId, selectedAssignments, includeCustomFields }) => ({
    type: actionTypes.DOWNLOAD_TEMPLATE_VISIT_DETAILS_CSV,
    mPlanId,
    selectedAssignments,
    includeCustomFields,
});

export const getAssignmentsVisitDetailsCsvDataAction = ({ mPlanId }) => ({
    type: actionTypes.GET_ASSIGNMENTS_VISIT_DETAILS_CSV,
    mPlanId,
});

export const setAssignmentsVisitDetailsCsvAction = ({
    hasLocationOverrides,
    visitsDetailed,
    averageTime,
    averagePayRate,
}) => ({
    type: actionTypes.SET_ASSIGNMENTS_VISIT_DETAILS_CSV,
    hasLocationOverrides,
    visitsDetailed,
    averageTime,
    averagePayRate,
});

export const removeAssignmentsVisitDetailsCsvDataAction = ({ mPlanId }) => ({
    type: actionTypes.REMOVE_ASSIGNMENTS_VISIT_DETAILS_CSV,
    mPlanId,
});

export const exportAssignmentsForSchedulingTemplateAction = ({ mPlanId }) => ({
    type: actionTypes.EXPORT_ASSIGNMENTS_FOR_SCHEDULING_TEMPLATE,
    mPlanId,
});

export const getPageFooterInfoAction = () => ({
    type: actionTypes.GET_PAGEFOOTER_INFO,
});

export const setPageFooterInfoAction = (currentBranch) => ({
    type: actionTypes.SET_PAGEFOOTER_INFO,
    currentBranch,
});
export const downloadAssignmentsQuickSelectUploadTemplateAction = () => ({
    type: actionTypes.DOWNLOAD_ASSIGNMENTS_QUICK_SELECT_UPLOAD_TEMPLATE,
});

export function setImportSelectionAction(importSelection) {
    return {
        type: actionTypes.SET_IMPORT_SELECTION,
        importSelection,
    };
}

export function setImportFileAction(file) {
    return {
        type: actionTypes.SET_IMPORT_FILE,
        file,
    };
}

export function setImportProgressStartAction() {
    return {
        type: actionTypes.SET_IMPORT_PROGRESS_START,
    };
}

export function setImportProgressDoneAction() {
    return {
        type: actionTypes.SET_IMPORT_PROGRESS_DONE,
    };
}

export function setImportErrorMessageAction(errorMsg) {
    return {
        type: actionTypes.SET_IMPORT_ERROR_MESSAGE,
        errorMsg,
    };
}

export function clearImportErrorMessageAction() {
    return {
        type: actionTypes.CLEAR_IMPORT_ERROR_MESSAGE,
    };
}
